var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select2',{attrs:{"id":_vm.uuid,"value":_vm.value,"settings":_vm.settings,"options":_vm.options},on:{"change":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }